<template>
  <div v-bind="$attrs">
    <v-item-group
      v-model="value"
      :multiple="multiple"
      :mandatory="mandatory !== undefined ? mandatory : !multiple"
      class="d-flex gap-4"
      :class="{ 'flex-wrap': wrap }"
    >
      <slot></slot>
    </v-item-group>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  type SoRadioCardType = number | number[] | string | string[] | null

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: [Number, String, Array] as PropType<SoRadioCardType>,
        default: null,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      mandatory: {
        type: Boolean,
        default: undefined,
      },
      /** Allow the cards to wrap onto multiple rows instead of one row. */
      wrap: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get(): SoRadioCardType {
          return this.modelValue
        },
        set(val: SoRadioCardType) {
          this.$emit("update:modelValue", val)
        },
      },
    },
  })
</script>

<style>
  .so-radio-card {
    border: 1px solid rgb(var(--v-theme-border));
  }
  .so-radio-card:focus-visible {
    outline: var(--theme-outline);
  }
</style>
